import
{
  RezzilLogoContainer,
  RezzilLogo,
} from './RezzilLogoBlack.styles';
import Logo from '../../../assets/images/rezzil-logo-full_black.png';

const RezzilLogoBlack = (sx) =>
{
  return (
    <RezzilLogoContainer sx={{ width: 300 }}>
      <RezzilLogo sx={{ width: '100%' }}
        src={Logo}
        alt='Rezzil'
      />
    </RezzilLogoContainer>
  );
};

export default RezzilLogoBlack;
